import { render, staticRenderFns } from "./OrderCheckout.vue?vue&type=template&id=7880d384&scoped=true&"
import script from "./OrderCheckout.vue?vue&type=script&lang=js&"
export * from "./OrderCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7880d384",
  null
  
)

export default component.exports